import type { FC } from 'react'

import { F0Card } from '@factorialco/f0-react'
import { Calendar, Feed, Person } from '@factorialco/f0-react/icons/app'
import { parseISO } from 'date-fns'
import { ReviewAnswerEvaluationFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { reviewTypePicker } from 'modules/performance_process/components/common/filters/reviewTypePicker'

export const EvaluationCard: FC<{
  evaluation: ReviewAnswerEvaluationFragment
  isSelected: boolean
  onSelect: () => void
}> = ({ evaluation, isSelected, onSelect }) => {
  const reviewer = evaluation.reviewerAccess
  const isAnonymous = !reviewer
  const reviewerName = isAnonymous ? i18n.t('common.anonymous_user') : reviewer.fullName

  return (
    <F0Card
      key={evaluation.id}
      avatar={
        isAnonymous
          ? { type: 'icon', icon: Person }
          : {
              type: 'person',
              firstName: '',
              lastName: reviewerName,
              src: buildUrl(reviewer.avatar) || '',
            }
      }
      selected={isSelected}
      onClick={onSelect}
      title={reviewerName}
      description={evaluation.performanceReviewProcess?.name || ''}
      metadata={[
        {
          icon: Feed,
          property: {
            type: 'text',
            value: reviewTypePicker(evaluation.evaluationType || ''),
          },
          tooltip: i18n.t(
            'performance_process.reviews.answer_evaluation.context_sidepanel.past_reviews_section.tooltip.review_type'
          ),
        },
        ...(evaluation.publishedAt
          ? [
              {
                icon: Calendar,
                property: {
                  type: 'text' as const,
                  value: i18nDateToString(parseISO(evaluation.publishedAt), 'ui_dmy_long'),
                },
                tooltip: i18n.t(
                  'performance_process.reviews.answer_evaluation.context_sidepanel.past_reviews_section.tooltip.published_at'
                ),
              },
            ]
          : []),
      ]}
      compact
    />
  )
}
